import type { ReactText } from "react";
import * as React from "react";
import * as palette from "../../palette";

interface IMenuLinkItemProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  href: string;
  children: ReactText;
}

export default function MenuLinkItem({ children, href, ...props }: IMenuLinkItemProps) {
  return (
    <li
      css={{
        marginLeft: -8,
        marginRight: -8,
      }}
    >
      <a
        href={href}
        css={{
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          width: "100%",
          margin: 0,
          padding: "0px 8px",
          overflow: "visible",
          color: palette.link,
          fontWeight: 500,
          fontSize: 14,
          lineHeight: 1.333,
          letterSpacing: 0.6,
          textDecoration: "none",
          backgroundColor: "transparent",
          border: "solid 1px transparent",
          borderRadius: 4,
          cursor: "pointer",
          transition: "all 60ms ease 0s",
          userSelect: "none",
          "&:hover": {
            textDecoration: "none",
            backgroundColor: palette.catskillWhite,
          },
          "&:visited": {
            color: palette.linkVisited,
          },
          "&:focus": {
            backgroundColor: palette.white,
            border: `solid 1px ${palette.cornflowerBlue}`,
            outline: "none",
            boxShadow: `0 0 0 3px ${palette.tropicalBlue}`,
          },
        }}
        {...props}
      >
        <span
          css={{
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          {children}
        </span>
      </a>
    </li>
  );
}
